module.exports = __webpack_public_path__ + "img/logo.140ec40c.png";